import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import FormatTooling from '../../../tooling/formatTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import FieldInfo from '../common/inputs/fieldInfo';

const VersionDetailPopup = props => {
  const {
    handleShowPopup,
    versionData,
    popupState
  } = props;
  return (
    <GlassPopup
      className="form_popup version_popup"
      title={(<FormattedMessage id="common.versions.popup.title"/>)}
      {...props}
    >
      {versionData && (
        <div>
          <FieldInfo 
            label={(<FormattedMessage id="common.versions.columns.date"/>)}
            value={FormatTooling.defaultsTextFormatTypes(versionData.created_at,Constants.crudGenerator.dataTypes.DATETIME)}
          />
          <FieldInfo 
            label={(<FormattedMessage id="metricAdmin.fields.unique"/>)}
            value={FormatTooling.defaultsTextFormatTypes(versionData.unique,Constants.crudGenerator.dataTypes.BOOLEAN)}
          />
          <FieldInfo 
            label={(<FormattedMessage id="metricAdmin.fields.data_type"/>)}
            value={(<FormattedMessage id={"metricAdmin.fields.selectValues.data_type." + versionData.data_type}/>)}
          />
          {versionData.validation_dimension && (
            <FieldInfo 
              label={(<FormattedMessage id="metricAdmin.fields.validation_dimension"/>)}
              value={versionData.validation_dimension.name}
            />
          )}
          {versionData.data_type==Constants.selectKeys.metric.dataType.OBJECT && (
            <FieldInfo 
              label={(<FormattedMessage id="metricAdmin.fields.object_definition"/>)}
              value={versionData.object_definition ? versionData.object_definition.map(item => 
                item.name + 
                " (" + intl.formatMessage({id: "metricAdmin.fields.selectValues.data_type." + item.data_type}) + ")"
              ).join(", ") : ""}
            />
          )}
          <FieldInfo 
            label={(<FormattedMessage id="metricAdmin.fields.dimensions"/>)}
            value={versionData.dimensions.map(item => item.name).join(", ")}
          />
        </div>
      )}
    </GlassPopup>
  );
};

export default VersionDetailPopup;



// WEBPACK FOOTER //
// ./source/client/components/virtualMetricAdmin/versionDetailPopup.jsx